import { TMenuSettings, TMenuColors } from '@treedis/tour-loader';
import { TIoTMenu, TServerMenuSettings } from './types';

export const getIoT = (m: TIoTMenu): [TMenuSettings, TMenuColors] => {
  const settings = {
    alwaysOpen: m?.alwaysOpen,
    tooltipOn: !m?.disableMenuTooltip,
    search: m?.enableSearchBar,
    categoryExpand: m?.expandMenuCategories,
    transparent: m?.enableTransparentBackground,
    fullScreenMobile: m?.fullScreenMobile,
    openOnLaunch: m?.openOnLaunch,
  };

  const colors = {
    bg: m?.colorSettings?.menuBgColor,
    hover: m?.colorSettings?.menuActiveColor,
    text: m?.colorSettings?.menuTxtColor,
    open: m?.colorSettings?.openedMenuColor,
    search: m?.colorSettings?.searchButtonColor,
    scrollbar: m?.colorSettings?.scrollbarColor,
  };

  return [settings, colors];
};

export const getBM = (m: TServerMenuSettings): [TMenuSettings, TMenuColors] => {
  const settings = {
    alwaysOpen: m?.menuAlwaysOpenDesktop,
    tooltipOn: m?.menuTooltipOn,
    search: m?.menuSearch,
    categoryExpand: m?.menuCategoryExpand,
    transparent: m?.enableTransparentBg,
    fullScreenMobile: m?.fullScreenMobile,
    openOnLaunch: m?.menuOnStart,
  };

  const colors = {
    bg: m?.menuBgColor,
    hover: m?.menuActiveColor,
    text: m?.menuTxtColor,
    open: m?.openedMenuColor,
    search: m?.searchButtonColor,
    scrollbar: m?.scrollbarColor,
    btnBg: m?.bookColor,
    btnHover: m?.bookActiveColor,
    btnText: m?.bookTxtColor,
  };

  return [settings, colors];
};
